<form [formGroup]="form" novalidate>
    <div class="row">
        <div class="column small-12">
            <h1 class="middle">{{ 'LOYALTY_HEADLINE' | resource:'Passengers' }}</h1>
            <div [innerHTML]="'LOYALTY_CARD_IMAGES' | resource"></div>
            <div id="linkedCard" *ngIf="cardNumberExistInUserProfile" [innerHTML]="'LOYALTY_CARD_IS_LINKED' | resource"></div>
            <div id="unLinkedCard" *ngIf="!cardNumberExistInUserProfile" [innerHTML]="'LINK_LOYALTY_CARD' | resource"></div>
        </div>
    </div>

    <div class="row">
        <div class="column small-12 medium-6">
            <div class="row">
                <div class="column large-12">
                    <div class="row">
                        <div class="column small-5 medium-5 large-6 prefix field">
                            <input value="{{model.preCardNumber}}" readonly tabIndex="-1" [disabled]="cardNumberExistInUserProfile" />
                        </div>
                        <div class="column small-7 medium-7 large-6 cardnumber field">
                            <input *ngIf="!cardNumberExistInUserProfile" type="tel" [textMask]="{mask: mask}" formControlName="cardNumber" placeholder="___________"
                                [validIfEmpty]="formCardNumber" />
                            <input *ngIf="cardNumberExistInUserProfile" type="text" formControlName="cardNumber" />
                        </div>
                        <div class="column small-3 large-5"></div>
                    </div>
                </div>
                <div class="column large-12">
                    <sbw-button *ngIf="cardNumberExistInUserProfile" type="secondary" id="removeButton" (clicked)="removeCardFromUserProfile()" [text]="'LOYALTY_REMOVE' | resource"></sbw-button>
                </div>
                <div class="column large-12">
                    <span id="invalidCard" *ngIf="formCardNumber.dirty && formCardNumber.invalid && formCardNumber.errors.checkCardNumber" class="field-validation-error">{{'VALIDATION_LOYALTYCARD_NOT_VALID' | resource}}</span>
                    <span id="validCard" *ngIf="formCardNumber.value && formCardNumber.dirty && formCardNumber.valid" class="field-validation-ok">{{'VALIDATION_LOYALTYCARD_VALID' | resource}}</span>
                    <span id="cardCouldNotBeRemoved" *ngIf="couldNotRemoveCardFromProfile" class="field-validation-error">{{'VALIDATION_LOYALTYCARD_COULD_NOT_BE_REMOVED_FROM_PROFILE' | resource}}</span>
                </div>
                <div *ngIf="!cardNumberExistInUserProfile" class="column small-12 half-gutter">
                    <span id="loyaltyNote">{{'LOYALTY_NOTE' | resource}}</span>
                </div>
            </div>
        </div>
        <div id="loyaltyCard" class="column large-6 medium-6 small-12" [innerHTML]="'LOYALTY_CARD' | resource"></div>
    </div>
</form>